import { Accept } from "react-dropzone";

export { EditImage } from "./ImageEdit";
export { MprcImageSelection } from "./MprcImageSelection";
export { MprcImageSelectionDialog } from "./MprcImageSelectionDialog";
export { MprcImageUpload } from "./MprcImageUpload";

export interface FileToUpload {
    sourceDataOrUrl: string | null;
    name: string;
    contentType: string;
}

export interface PureFileToUpload {
    source: File;
}

export interface ImageSelectionResult {
    source: FileToUpload;
    editedImage: FileToUpload | null;
}

export interface ImageSelectionProps {
    acceptedFiles?: Accept;
    allowEdit: boolean;
    dimension?: ImageDimension;
    adjustImageDimensionToRatio?: boolean;
    maxSize: number | null;
    backgroundColor: string;
    fitMode?: ImageSelectionFit;
    onChange: (image: ImageSelectionResult | null) => void;
    onError: (message: string) => void;
}

export const ImageSelectionSolidBackgroundColor = '#E0E0E0';

export type TabOptions = "library" | "local";

export type ImageSelectionBackgroundType = "solid" | "transparent";

export type ImageSelectionFit = "default" | "cover";